// extracted by mini-css-extract-plugin
export default {"container":"BreadCrump_container__MDZPE","content":"BreadCrump_content__wkz6k","spacer":"BreadCrump_spacer__eBK14"};